export default __webpack_public_path__ + "static/media/stelmark.32e46282.png";